module.exports = __webpack_public_path__ + "img/hotel5.c3cfbaf6.png";